export default function Services() {
    return (
        <div className="container mx-auto my-16 lg:flex flex-row">
            <div className="mx-4 my-2 p-8 flex flex-col justify-between lg:w-1/2 shadow-xl rounded-3xl">
                <h1 className="pb-4 text-4xl text-blue-800">Servicios personalizados</h1>
                <p className="md:text-xl"> Algunos clientes necesitan una página web, otros una app.
                Sean cual sean tus requerimientos, nosotros tenemos las herramientas para llevar a cabo tu idea.
                Incluso si tienes dudas sobre tu nueva idea de emprendimiento, te podemos ayudar a concretarla.
                </p>
            </div>
            <div className="mx-4 my-2 p-8 flex flex-col justify-between lg:w-1/2 shadow-xl rounded-3xl">
                <h1 className="pb-4 text-4xl text-blue-800">Páginas y aplicaciones web</h1>
                <div className="md:text-xl">
                    <p>Puedo realizar soluciones como ecommerce, venta online, páginas web corporativas, sistemas de inventario, back-office o cualquier otro tipo de aplicación web.</p>
                    <p>Todas las páginas web se adaptan a tu smartphone, tablet o computadora manteniendo intacto el estilo.</p>
                </div>
            </div>


        </div>)
}